import { PASSWORD_LENGTH } from "./mappings";

export const isValidPasswordLength = (password) => password.length >= PASSWORD_LENGTH
export const isValidPasswordLower = (password) =>
  /([a-z])/.test(password)
export const isValidPasswordUpper = (password) =>
  /([A-Z])/.test(password)
export const isValidPasswordDigit = (password) => /(\d)/.test(password)
export const isValidPasswordSpecial = (password) =>
  /([^A-Za-z0-9])/.test(password)